import { render, staticRenderFns } from "./UserAnswers.vue?vue&type=template&id=00c6895e&"
import script from "./UserAnswers.vue?vue&type=script&lang=js&"
export * from "./UserAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports